import axios from "axios";
import { SET_ERROR, SAVE_PERMISSIONS, GET_ROLE_PERMISSIONS, CLIENT_PERMISSIONS } from "../../types";
import ToastMessage from '../../../components/toast';

export const savePermissions = (payload) => {
    return async (dispatch) => {
        await axios.post(`api/permission/save-permissions`, payload).then(response => {
            dispatch({
                type: SAVE_PERMISSIONS,
                payload: response.data,

            });
            ToastMessage("Successfully submitted", "success");
            dispatch({
                type: CLIENT_PERMISSIONS,
                payload: response.data
            })
        }).catch(e => {
            ToastMessage(e, "error");
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            })
        })
    }
};



export const getRolePermissions = (roleId) => {
    return async (dispatch) => {
        await axios.get(`api/permission/get-role-permissions/${roleId}`).then(res => {
            dispatch({
                type: GET_ROLE_PERMISSIONS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        });
    };
};

export const getCompanyPermissions = (companyId, filterInactive) => {
    return async dispatch => {
        await axios.get(`api/permission/get-company-permissions/${companyId}${filterInactive ? "/filterInactive" : ""}`).then(res => {
            dispatch({
                type: CLIENT_PERMISSIONS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        });
    };
};

/**
 * @deprecated use getCompanyPermissions
 * @param {*} clientId 
 * @returns 
 */
export const getReportPermissions = async (clientId) => {
    const payload = { company: clientId };
    let response = await axios.post('api/permission/get-available-permission', payload);
    return response.data || []
};


export const getCompanyByPermission = async (payload) => {
    return await axios.post("api/permission/get-company-by-permission", payload).catch((e) => { console.log(e) });
};